/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { UpdateNotificationPrefsResponse, UpdateNotificationPrefsVars } from '../openapi-types.gen.js';

export type { UpdateNotificationPrefsResponse, UpdateNotificationPrefsVars } from '../openapi-types.gen.js';

export const useUpdateNotificationPrefs = createMutationHook<UpdateNotificationPrefsVars, UpdateNotificationPrefsResponse, unknown>({
  specName: 'useUpdateNotificationPrefs',
  path: '/v1/users/me/notification-prefs',
  method: 'PATCH',
  resolveUrl: (vars: UpdateNotificationPrefsVars) => `/v1/users/me/notification-prefs`,
  buildBody: (vars: UpdateNotificationPrefsVars) => ({ inApp: vars.inApp }),
  parseResponse: (raw: unknown): UpdateNotificationPrefsResponse => raw as UpdateNotificationPrefsResponse,
  optimistic: [{
    queryKey: ['users', 'detail'],
    apply: (prev: any, vars: UpdateNotificationPrefsVars) => {
      if (prev === undefined) return prev;
      let next: any = prev;
      if (vars.inApp !== undefined) next = { ...next, inApp: vars.inApp };
      return next;
    },
  }],
  
  
});
